import ApplicationController from "../application_controller.js";
import moment from "moment";
import * as easepick from "@gothassos/easepick-bundle";
window.easepick = easepick; //* fixes issues loading plugins

export default class extends ApplicationController {
  static values = {
    locale: { type: String, default: "en-US" },
    css: { type: String, default: "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.0/dist/index.css" },
  };
  static targets = ["calendar", "calendarContainer", "starts", "ends", "duration"];

  connect() {
    this.log_function("connect");

    this.instance = new easepick.create({
      lang: this.currentLocale,
      element: this.calendarTarget,
      inline: true,
      firstDay: 1,
      plugins: [
        "RangePlugin",
        // "AmpPlugin",
        "LockPlugin",
      ],
      RangePlugin: {
        tooltipNumber(num) {
          return num - 1;
        },
        locale: this.nightsText,
      },
      AmpPlugin: {
        darkMode: false,
      },
      LockPlugin: {
        minDays: 2,
        maxDays: 365,
        selectForward: false,
        selectBackward: false,
        minDate: moment(),
      },
      css: [this.cssValue],
      setup: (picker) => {
        picker.on("preselect", (event) => {
          const custom_event = new CustomEvent("easepick-preselect", event);
          window.dispatchEvent(custom_event);
          return this._handleSelect(event);
        });
        picker.on("select", (event) => {
          const custom_event = new CustomEvent("easepick-select", event);
          window.dispatchEvent(custom_event);
          return this._handleSelect(event);
        });
      },
    });
  }

  _handleSelect(event) {
    this.log_function("_handleSelect", event);

    const { start, end } = event.detail;
    const startDate = start || false;
    const endDate = end || false;
    this.startsTarget.value = startDate ? moment(startDate).format("DD/MM/YYYY") : "";
    this.endsTarget.value = endDate ? moment(endDate).format("DD/MM/YYYY") : "";
    this.durationTarget.value = startDate && endDate ? moment(endDate).diff(moment(startDate), "days") : "";
    const custom_event = new CustomEvent("easepick-handle-select", event);
    window.dispatchEvent(custom_event);
  }

  shake() {
    this.log_function("shake");

    if (!this.shaking) {
      this.calendarContainerTarget.classList.add("animate__animated", "animate__shakeX");
      this.shaking = true;

      setTimeout(() => {
        this.calendarContainerTarget.classList.remove("animate__animated", "animate__shakeX");
        this.shaking = false;
      }, 1000);
    }
  }

  disconnect() {
    this.log_function("disconnect");

    this.instance.destroy();
  }

  get currentLocale() {
    this.log_function("get currentLocale");

    switch (this.localeValue) {
      case "en":
        return "en-US";
      case "el":
        return "el-GR";
      default:
        return "en-US";
    }
  }

  get nightsText() {
    this.log_function("get nightsText");

    switch (this.localeValue) {
      case "en":
        return { one: "night", other: "nights" };
      case "el":
        return { one: "διανυκτέρευση", other: "διανυκτερεύσεις" };
      default:
        return { one: "night", other: "nights" };
    }
  }

}
